/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { subscriptionsResume } from "../../funcs/subscriptionsResume.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string(),
};

export const tool$subscriptionsResume: ToolDefinition<typeof args> = {
  name: "subscriptions-resume",
  description: `Resume a subscription.

Resume a subscription. Subscription must be in paused or scheduled_cancel status.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await subscriptionsResume(
      client,
      args.id,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
